import React, { useRef, useState } from "react";
import homeIcon from "../assets/icons/thinkIcons/Home.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import HouseIMG from "../assets/img/house_predictIMG.jpg";
import HouseIMG2 from "../assets/img/House Img2.jpg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PropertyPrediction = () => {
  const [formData, setFormData] = useState({
    Area: "", // keep as string
    BHK: "",
    Bathroom: "",
    Parking: "",
    Property_Type: "",
    Furnished_Status: "",
    City: "",
    Locality_Category: "",
    Public_Transport_Accessibility: "",
    Facing: "",
    Security: "",
    Age_of_Property: "",
  });

  const [predictionResult, setPredictionResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const resultRef = useRef(null);
  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handlePrediction = async () => {
    // Check if any field is empty
    for (let [key, value] of Object.entries(formData)) {
      if (value === "" || value === null || value === undefined) {
        toast.error(`${key.replace(/_/g, " ")} is required`, {
          position: "top-right",
          autoClose: 3000,
        });
        return; // stop execution
      }
    }

    try {
      setLoading(true);

      const payload = {
        Area: parseFloat(formData.Area),
        BHK: parseInt(formData.BHK),
        Bathroom: parseInt(formData.Bathroom),
        Parking: parseInt(formData.Parking),
        Property_Type: formData.Property_Type,
        Furnished_Status: formData.Furnished_Status,
        City:
          formData.City.charAt(0).toUpperCase() +
          formData.City.slice(1).toLowerCase(),
        Locality_Category: formData.Locality_Category,
        Public_Transport_Accessibility: formData.Public_Transport_Accessibility,
        Facing: formData.Facing,
        Security: formData.Security,
        Age_of_Property: parseInt(formData.Age_of_Property),
      };

      const endpoint = "/house_prediction";
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      setPredictionResult(res.data.prediction);

      // 👇 scroll to result after prediction
      setTimeout(() => {
        resultRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } catch (error) {
      console.error("Property Prediction API Error:", error);
      toast.error("Something went wrong with prediction", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-2 md:p-8 lg:p-12">
      {/* Header Row */}
      <div className="flex justify-end">
        <button
          className="flex items-center gap-2 border  px-3 py-2 rounded-full cursor-pointer"
          onClick={() => navigate("/user/dashboard")}
        >
          <img src={homeIcon} className="w-[18px] h-[18px]" />
          <span className="text-xs">Home</span>
        </button>
      </div>

      {/* Top Card */}
      <div className="border-1 rounded-md mt-2 md:mt-4 flex p-2 md:p-3 gap-4  border-blue-custom">
        <img
          src={HouseIMG}
          alt="Advisory Tool"
          className="w-full max-w-[200px] min-w-[160px] h-[120px] object-cover rounded-md"
        />
        <div className="">
          <h2 className="textcolor font-semibold text-xl">
            India House Price Predictor
          </h2>
          <p className="textsec text-sm">
            Predict Price with confidence, for better planning and decisions.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="desc-Text border-l-4 border-l-desc-Text pl-4 mt-4 text-lg font-semibold">
        <p className="font-medium m-0">
          Enter property details to predict the price
        </p>
      </div>

      {/* Form */}
      <form className="my-2 sm:my-4 py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <NumberInput
          label="Area (sq ft)"
          value={formData.Area}
          setValue={(v) => handleChange("Area", parseFloat(v))}
        />
        <NumberInput
          label="BHK"
          value={formData.BHK}
          setValue={(v) => handleChange("BHK", parseInt(v))}
        />
        <NumberInput
          label="Bathrooms"
          value={formData.Bathroom}
          setValue={(v) => handleChange("Bathroom", parseInt(v))}
        />
        <NumberInput
          label="Parking Spaces"
          value={formData.Parking}
          setValue={(v) => handleChange("Parking", parseInt(v))}
        />
        <NumberInput
          label="Age of Property (Years)"
          value={formData.Age_of_Property}
          setValue={(v) => handleChange("Age_of_Property", parseInt(v))}
        />
        <TextInput
          label="City"
          value={formData.City}
          setValue={(v) => handleChange("City", v)}
        />
        <SelectInput
          label="Property Type"
          value={formData.Property_Type}
          setValue={(v) => handleChange("Property_Type", v)}
          options={["Apartment", "Independent House", "Villa"]}
        />
        <SelectInput
          label="Furnished Status"
          value={formData.Furnished_Status}
          setValue={(v) => handleChange("Furnished_Status", v)}
          options={["Unfurnished", "Semi-furnished", "Furnished"]}
        />

        <SelectInput
          label="Locality Category"
          value={formData.Locality_Category}
          setValue={(v) => handleChange("Locality_Category", v)}
          options={["Premium", "Mid-tier", "Affordable"]}
        />
        <SelectInput
          label="Public Transport Accessibility"
          value={formData.Public_Transport_Accessibility}
          setValue={(v) => handleChange("Public_Transport_Accessibility", v)}
          options={["High", "Medium", "Low"]}
        />
        <SelectInput
          label="Facing"
          value={formData.Facing}
          setValue={(v) => handleChange("Facing", v)}
          options={["North", "East", "South", "West"]}
        />
        <SelectInput
          label="Security"
          value={formData.Security}
          setValue={(v) => handleChange("Security", v)}
          options={["Yes", "No"]}
        />
      </form>

      {/* Button */}
      <div className="mt-8 flex justify-center">
        <button
          onClick={handlePrediction}
          disabled={loading}
          className="bgbtn1 textwhite px-6 py-2 rounded shadow hover:bg-[#1376c2] transition"
        >
          {loading ? "Processing..." : "Predict Price"}
        </button>
      </div>

      {/* Result */}
      {predictionResult && (
        <div className="border-1 border-blue-custom rounded-lg mt-4 p-3 md:p-8 lg:p-12">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-800">
              Prediction Result
            </h2>
            <p className="text-gray-600">
              Predicted property price based on your inputs.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold textcolor mb-2">
              Prediction Result
            </h3>

            <div className="relative">
              <img
                src={HouseIMG2}
                alt="Prediction"
                className="w-full h-40 object-cover object-center"
              />
              <div
                className="absolute top-2 left-2 textcolor font-medium px-4 py-1 rounded shadow"
                style={{
                  background: "linear-gradient(to right, #71B7EE 5%, white 5%)",
                }}
              >
                Prediction Result : {predictionResult ?? "N/A"} (in Lakhs)
              </div>
            </div>
            <p className="text-xs textsec p-2">
              Note: This image is a generic placeholder for the predicted
              property price.
            </p>
          </div>

          <div>
            <h4 className="text-md font-semibold textprimary mb-3">
              Input Data Sent
            </h4>
            <div className="overflow-x-auto" ref={resultRef}>
              <table className="min-w-full text-center text-sm border-1 border-blue-custom rounded-xl">
                <thead className="textcolor">
                  <tr>
                    {Object.keys(formData).map((key) => (
                      <th
                        key={key}
                        className="border-1 border-blue-custom px-4 py-2"
                      >
                        {key.replace(/_/g, " ")}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {Object.values(formData).map((val, idx) => (
                      <td
                        key={idx}
                        className="border-1 border-blue-custom px-4 py-2"
                      >
                        {typeof val === "string"
                          ? val
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                              )
                              .join(" ")
                          : val ?? "--"}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Reusable components
const NumberInput = ({ label, value, setValue }) => (
  <div>
    <label className="block textblack text-sm font-semibold mb-1">
      {label}
    </label>
    <input
      type="number"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
      placeholder="Enter the Number"
      required
    />
  </div>
);

const TextInput = ({ label, value, setValue }) => (
  <div>
    <label className="block textblack text-sm font-semibold mb-1">
      {label}
    </label>
    <input
      type="text"
      value={value}
      onChange={(e) => {
        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allow letters and spaces only
        setValue(onlyLetters);
      }}
      className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
      required
      placeholder="Enter the City Name"
    />
  </div>
);

const SelectInput = ({ label, value, setValue, options }) => (
  <div>
    <label className="block textblack text-sm font-semibold mb-1">
      {label}
    </label>
    <select
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
    >
      <option value="">Select {label}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  </div>
);

export default PropertyPrediction;
